import classNames from 'classnames'
import { FC } from 'react'
import { NavLink } from 'react-router-dom'

interface Props {}

const StartPage: FC<Props> = () => {
  return (
    <div
      className={classNames(
        'absolute inset-0 flex-col flex justify-center items-center text-[30px] bg-white  transition-all duration-500 text-center'
      )}
      style={{ width: '100%', height: '100%', zIndex: 20 }}
    >
      <div className='max-w-lg p-8'>
        <img src='/logo512.png' alt='logo' className='w-32 mx-auto' />
        <div className='h-4' />
        <h1>Visual Stages</h1>
        <p>
          Välkommen, här kan du se vilka scener som finns i Norrköping. Navigera dig mellan scenerna med menyn nere i mitten eller med
          tabellen längst upp. Hoppas du hittar vad du söker! Kontakta oss gärna på 
          <a href='mailto:evenemang@norrkoping.se'>evenemang@norrkoping.se</a>.
        </p>
        <div className='h-4' />
        <p className='text-[24px] font-semibold text-black'>Navigering</p>
        <p>
          Dra musen för att flytta på kameran
          <br />
          Shift + Dra för att rotera
          <br /> Scrolla för att zooma
        </p>
        <div className='h-4' />
        <NavLink to='/navigate'>
          <button className='bg-white p-2 mb-4 px-4 rounded-xl border-[1px] shadow-lg border-gray-800 text-gray-800 text-sm font-semibold hover:bg-primary-500 transition-all'>
            Starta
          </button>
        </NavLink>
      </div>
    </div>
  )
}

export default StartPage
